"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationCreateDTOToJSON = exports.OrganizationCreateDTOFromJSONTyped = exports.OrganizationCreateDTOFromJSON = exports.instanceOfOrganizationCreateDTO = void 0;
/**
 * Check if a given object implements the OrganizationCreateDTO interface.
 */
function instanceOfOrganizationCreateDTO(value) {
    if (!('name' in value))
        return false;
    return true;
}
exports.instanceOfOrganizationCreateDTO = instanceOfOrganizationCreateDTO;
function OrganizationCreateDTOFromJSON(json) {
    return OrganizationCreateDTOFromJSONTyped(json, false);
}
exports.OrganizationCreateDTOFromJSON = OrganizationCreateDTOFromJSON;
function OrganizationCreateDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
    };
}
exports.OrganizationCreateDTOFromJSONTyped = OrganizationCreateDTOFromJSONTyped;
function OrganizationCreateDTOToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
    };
}
exports.OrganizationCreateDTOToJSON = OrganizationCreateDTOToJSON;
//# sourceMappingURL=OrganizationCreateDTO.js.map